import { mapperBlockIndexContentGroup } from '../block-index-content-group/mapper-block-index-content-group'
import { mapperModuleMedia } from '../../modules/mappers'
import type { MapperImageOptions, MapperOptions } from '~/types'

export const mapperBlockIndexChapter = (data: any, options: MapperOptions) => {
  try {
    if (!data) {
      return null
    }

    const imageOptions: MapperImageOptions = {
      sizes: {
        small: { width: 334, height: 334, aspectRatio: '1/1' },
        medium: { width: 690, height: 690, aspectRatio: '1/1' },
        large: { width: 696, height: 696, aspectRatio: '1/1' }
      }
    }

    return {
      id: data.sys?.id || '',
      title: data.title || '',
      contentType: data.contentType,
      description: data.description || '',
      navigationTitle: data.navigationTitle || '',
      coverImage: mapperModuleMedia(data.coverImage, imageOptions),
      contentGroups:
        data.contentGroupsCollection?.items.map((item: any) => mapperBlockIndexContentGroup(item, options)) || []
    }
  } catch (error) {
    console.error('Mapper Block Index Chapter failed,', error)
  }
}
